import React from "react";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  TextField,
  Typography,
} from "@mui/material";

import { DatePicker } from "@mui/x-date-pickers";
import { MAX_DATE, MIN_DATE } from "static/constants";
import dayjs from "dayjs";
import { getFormattedDate } from "utils/date";
import { DATE_FORMAT } from "static/date";

const DatapointInput = (props) => {
  const { type, formChanged, label, handleReset, name, value, onChange } =
    props;

  const renderComponent = () => {
    const inputMap = {
      text: <TextField {...props} />,
      number: (
        <TextField
          inputProps={{
            min: 0,
          }}
          {...props}
        />
      ),
      checkbox: (
        <FormControl>
          <FormControlLabel control={<Checkbox />} label={label} {...props} />
          {Object?.hasOwn(formChanged, name) && (
            <Grid container alignItems="center" spacing={1}>
              <Grid item>
                <FormHelperText>{`You have ${
                  formChanged?.[name] === true ? "enable" : "disable"
                } ${label}`}</FormHelperText>
              </Grid>
              <Grid item>
                <Typography
                  variant="subtitle2"
                  color="secondary"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleReset(name)}
                >
                  Reset
                </Typography>
              </Grid>
            </Grid>
          )}
        </FormControl>
      ),
      date: (
        <DatePicker
          disableToolbar
          variant="inline"
          format="MM/DD/YYYY"
          maxDate={dayjs(MAX_DATE)}
          minDate={dayjs(MIN_DATE)}
          value={value ? dayjs(new Date(value)) : null}
          onChange={(date) => {
            const formattedDate = getFormattedDate(date, DATE_FORMAT.DEFAULT);
            onChange(formattedDate);
          }}
          sx={{ margin: `0 !important` }}
          slotProps={{
            textField: {
              fullWidth: true,
            },
          }}
        />
      ),
    };
    return (
      <Grid item style={{ marginBottom: "15px" }}>
        {inputMap[type]}
      </Grid>
    );
  };

  return <>{renderComponent()}</>;
};
export default DatapointInput;
